export default url => url.indexOf('://') >= 0;



// WEBPACK FOOTER //
// helpers/isLinkExternal.js